module.exports = __webpack_public_path__ + "img/directors_remuneration_banner.4d2d2869.jpg";